<template>
    <section>
        <div class="container">
			<div class="row mb-2" style="margin-top: 124px;">
                <div class="col">   
					<img src="@/assets/img/offline.gif" style="display: block; margin-left: auto; margin-right: auto;max-width: 140px;">
					<h1 class="text-center" style="font-family: 'Cookie', cursive;margin-bottom: 0;">{{restaurant_name}}</h1>
					<h1 class="text-center" style="font-family: 'Cookie', cursive;font-size: 69px;">is offline</h1>	
                </div> 
            </div>
        </div>
    </section>
</template>

<script>
export default {
  name: 'Offline',
  data: function(){      
    return {
      restaurant_name:null,
    }
  },
  mounted: function(){

    this.restaurant_name = localStorage.getItem('restaurant_name');
    var self = this;
    setTimeout(function(){
      console.log("test");
      var config = {
      method: 'get',
      url: process.env.VUE_APP_BASE_URI+'/api/userapi/restaurant/landing/'+localStorage.getItem('restaurant_id')+'/'+localStorage.getItem('table_id')+'/',
      headers: {
      }
    };
    self.axios(config)
    .then(response => {
      if(response.status){
        var homepage = '/restaurant/'+localStorage.getItem('restaurant_id')+'/'+localStorage.getItem('table_id')
        self.$router.push(homepage);
      }
    });
    },10000)
  }
}
</script>